module.exports = __webpack_public_path__ + "src/assets/img/index_restaurant.bad44d8e.jpg";